// home.js
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Fetch from '../../../../../core/util/core/Fetch';
import config from '../../../../config/config';
import Toast from '../../../../../core/components/core/Util/Toast/Toast';
import CustomList from '../Util/List/CustomList/CustomList'
import CustomListContainer from '../Util/List/CustomList/CustomListContainer'
import { loadData } from '../Util/List/CustomList/loadData';

import '../home/Home.css';

const Documentation = ({ scope = 'entity', labelTitle = 'Documentações' }) => {
  const sessionSelector = useSelector((state) => { return state.core.session });
  const friendly_url = sessionSelector.pdc_project_friendly_url;

  const [customTabFilters, setCustomTabFilters] = useState([])

  useEffect(() => {
    const loadData = async () => {
      if (friendly_url) {
        const documentationCategories =
          await Fetch.post(`${config.endpoints.backend}portal/getalldocumentationcategories`, { filter: { friendly_url } })

        let customTabFiltersToAdd = []
        for (const category of documentationCategories) {
          customTabFiltersToAdd.push(
            {
              label: category.name,
              filters: {
                pdc_category_id: category.id
              }
            }
          )
        }

        setCustomTabFilters(customTabFiltersToAdd)
      }

    };

    loadData();
  }, [])

  const dispatch = useDispatch()

  setInterval(() => {
    dispatch({ type: 'UPDATE_SESSION', key: 'current_tab_filter_notifications', value: [5, 6] });
  }, 1000)

  const paths = {
    endpoint: config.endpoints.backend + 'portal/getalldocumentations',
    endpointGetAllDocumentTypes: config.endpoints.backend + 'portal/getalldocumenttypes'
  }

  const filters = {
    validateOnChange: true,
    showGoBackButton: false,
    showSubmitButton: false,
    handleSubmit: loadData,
    fields: [
      {
        name: 'pdc_document_type_id',
        type: 'select',
        label: 'Tipo',
        options: [],
        optionsEndpoint: {
          endpoint: paths.endpointGetAllDocumentTypes,
          label: 'name',
          value: 'id'
        },
        validations: {
          required: false
        },
        columnSize: 3
      },
      {
        name: 'filtro',
        type: 'submit',
        label: 'Pesquisar',
        columnSize: 1
      },
      {
        name: 'reset',
        type: 'reset',
        label: 'Limpar',
        columnSize: 2
      },
    ]
  }

  const list = {
    labelTitle,
    key_data_rows: `custom_list_data_documentations_${scope}`,
    icon: 'fa-file-lines',
    canDownload: true,
    fieldToDownload: 'file',
    filter: {
      friendly_url,
      scope
    },
    tabFilters: customTabFilters,
    formFilters: filters,
    columns: [
      {
        name: 'document_type',
        label: 'Tipo de Documento'
      },
      {
        name: 'title',
        label: 'Título'
      },
      {
        name: 'publish_date',
        label: 'Data de Publicação'
      }
    ]
  };

  return (
    <CustomListContainer
      canAdd={false}
      labelTitle={list.labelTitle}
      icon={list.icon}
      content={<CustomList list={{ ...list, ...paths }} />}
    />
  );
};

export default Documentation;
